<template>
  <div>
    <top-title class="theTitle" :name="name" style="min-width: 1046px"></top-title>
    <div class="content-box">
      <div class="tab-line">
        <div class="tab-item" :class="{ active: tabIndex == 0 }" @click="switchTab(0)">
          全部
        </div>
        <div class="tab-item" :class="{ active: tabIndex == 2 }" @click="switchTab(2)">
          系统模板
        </div>
        <div class="tab-item" :class="{ active: tabIndex == 3 }" @click="switchTab(3)">
          自定义模板
        </div>
        <div class="tab-item" :class="{ active: tabIndex == 1 }" @click="switchTab(1)">
          官方模板
        </div>
        <div class="tab-item" :class="{ active: tabIndex == 4 }" @click="switchTab(4)">
          官方模板申请
        </div>
        <div class="tab-item" :class="{ active: tabIndex == 5 }" @click="switchTab(5)">
          富信模板
        </div>
        <div class="tab-item" :class="{ active: tabIndex == 6 }" @click="switchTab(6)">
          卡片模板
        </div>
        <div class="tab-item" :class="{ active: tabIndex == 7 }" @click="switchTab(7)">
          卡片素材
        </div>
      </div>
      <div class="footTips" style="height: 118px; position: relative" v-if="tabIndex == 4">
        <img src="@/assets/images/new_icon_waring_yellow.png" style="
                                                      display: inline-block;
                                                      float: left;
                                                      position: absolute;
                                                      width: 14px;
                                                      height: 14px;
                                                      color: #ffffff;
                                                      margin: 1px 4px 0 0;
                                                      top: 9px;
                                                    " />
        <span style="margin-left: 18px; line-height: 21px">使用说明：<br />
          1.官方模板审核时间为：每周五16:00-18:00，引用模板之前请提前申请。
          <br />
          2.已经引用的模板无法删除，需关闭相应的任务或替换这些任务的短信模板后，再进行删除操作。
          <br />
          3.包含跳转链接的短信内容需满足以下填写规范：动词+页面名+链接
          <br />示例：点击加购x商品详情页> 3.cn/1l-dAxxx</span>
      </div>
      <!-- <div class="tip-box" :style="{color: globalBG}" v-if="tabIndex == 4">
        <p>使用说明：</p>
        <p>1.官方模板审核时间为：每周五16:00-18:00，引用模板之前请提前申请。</p>
        <p>2.已经引用的模板无法删除，需关闭相应的任务或替换这些任务的短信模板后，再进行删除操作。</p>
      </div> -->
      <div class="search-box" v-if="tabIndex == 4">
        <el-form ref="formSearch" :inline="true" :model="formData" label-width="80px">
          <el-form-item label="模板内容:">
            <el-input size="small" v-model="formData.content" placeholder="请输入模板内容" style="margin-right: 80px"></el-input>
          </el-form-item>
          <el-form-item label="模板ID:">
            <el-input size="small" v-model="formData.officialTemplateId" placeholder="请输入模板ID"
              style="margin-right: 80px"></el-input>
          </el-form-item>
          <el-form-item label="审核状态:">
            <el-select v-model="formData.approvalStatus">
              <el-option v-for="(item, index) in examineList" :key="index" :value="item.value"
                :label="item.label"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="btn_group">
          <el-button size="small" :disabled="tableLoading" class="search button-status5"
            @click="submitForm('formSearch')">
            <i class="el-icon-search" style="display: inline-block; width: 14px; height: 12px"></i>
            查询
          </el-button>
          <el-button size="small" class="reset" @click="resetForm">重置</el-button>
        </div>
      </div>
      <div class="btn-line" v-if="tabIndex == 3">
        <el-button type="primary" v-zoom="{ from: pageName, name: '添加栏目' }" @click="showAddColumnDialog"
          style="font-size: 14px">
          <img src="@/assets/images/member/new_establish.png" style="
                                                        display: inline-block;
                                                        float: left;
                                                        width: 14px;
                                                        height: 14px;
                                                        margin-right: 4px;
                                                      " />添加栏目
        </el-button>
        <el-button class="b1" @click="showDelColumnDialog" v-zoom="{ from: pageName, name: '删除栏目' }"
          style="font-size: 14px">删除栏目</el-button>
        <el-button class="b2" v-zoom="{ from: pageName, name: '创建模板' }"
          @click="showCreateModuleDialog(1)">创建模板</el-button>
      </div>
      <div class="btn-line" style="margin-top: 10px" v-if="tabIndex == 4">
        <el-button type="primary" v-zoom="{ from: pageName, name: '创建模板' }" @click="handleCreateO()">创建模板</el-button>
      </div>
      <div class="content-table">
        <div class="left-menu" v-if="tabIndex != 5 && tabIndex != 6 && tabIndex != 7 ">
          <div class="menu-item" v-for="(item, index) in moduleList" :key="index">
            <div class="first-menu" :class="{ active: selectIndex == index }" @click="handleClickFirst(index)">
              <span class="title">
                <template v-if="item.child">
                  <i class="el-icon-caret-right" v-if="!item.isExpand"></i>
                  <i class="el-icon-caret-bottom" v-else></i>
                </template>
                {{ item.title }}
              </span>
            </div>
            <div v-if="item.children" class="second-menu" :style="{
              height: !item.isExpand ? '0' : 28 * item.children.length + 'px',
            }">
              <p v-for="(itemSecond, indexSecond) in item.children" :class="{ active: selectSecondIndex == indexSecond }"
                :key="indexSecond" @click="handleClickFirst(index, indexSecond)">
                {{ itemSecond.title }}
              </p>
              <!-- <p class="active">周年庆</p> -->
            </div>
          </div>
        </div>
        <div class="table-content" v-if="tabIndex != 5 && tabIndex != 6 && tabIndex != 7">
          <el-table v-loading="tableLoading" tooltip-effect="light" :data="tableData"
            :header-cell-style="{ background: '#FAFAFA' }">
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>

            <el-table-column key="name" v-if="tabIndex == 4" label="模板名称" prop="name"> </el-table-column>
            <el-table-column key="dirTitle" v-if="tabIndex == 4" label="栏目分类" prop="dirTitle"> </el-table-column>
            <el-table-column label="模板内容" width="440px" key="content">
              <template slot="header" slot-scope="scope">
                <span>模板内容</span>
                <span class="table-message" v-if="!allShow" :style="{ color: '#7f85e9' }"
                  @click="allShow = true">展开全部</span>
                <span class="table-message" v-if="allShow" :style="{ color: '#7f85e9' }"
                  @click="allShow = false">单行显示</span>
              </template>
              <template slot-scope="scope">
                <div v-if="!allShow">
                  <el-popover placement="top-start" width="300" offset="100" trigger="hover"
                    :content="scope.row.content | enVToChinese">
                    <div class="module-content" slot="reference">
                      {{ scope.row.content | enVToChinese }}
                    </div>
                  </el-popover>
                </div>
                <div v-if="allShow">
                  <div>{{ scope.row.content | enVToChinese }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column key="officialTemplateId" v-if="tabIndex == 4" label="模板ID" prop="officialTemplateId">
            </el-table-column>
            <el-table-column label="字数" key="length">
              <template slot-scope="scope">{{ scope.row.content | enVToChineseLength }}</template>
            </el-table-column>
            <el-table-column key="crtime" v-if="tabIndex == 4" label="创建时间" prop="crtime"></el-table-column>
            <el-table-column v-if="tabIndex != 4" label="类型">
              <template slot-scope="scope">
                <span v-if="scope.row.type == '0'">自定义模板</span>
                <span v-if="scope.row.type == '1'">系统模板</span>
                <span v-if="scope.row.type == '2'">官方模板</span>
              </template>
            </el-table-column>
            <el-table-column v-if="tabIndex == 4" label="审核状态" key="approvalStatus">
              <template slot-scope="scope">
                <span v-if="scope.row.approvalStatus == '-1'">未提交</span>
                <span v-if="scope.row.approvalStatus == '0' || scope.row.approvalStatus == '3'">待审核</span>
                <span v-if="scope.row.approvalStatus == '1'">通过</span>
                <span v-if="scope.row.approvalStatus == '2' || scope.row.approvalStatus == '5'">
                  拒绝
                  <el-tooltip class="item" effect="dark" :content="scope.row.refuseReason" placement="top-start"
                    v-if='scope.row.refuseReason'>
                    <i class="el-icon-question" style="cursor: pointer;color: #ff5e61;"></i>
                  </el-tooltip>
                </span>
              </template>
            </el-table-column>
            <el-table-column v-if="tabIndex == 4" label="是否可用">
              <template slot-scope="scope">
                <span v-if="scope.row.status">启用</span>
                <span v-else>禁用</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150px">
              <template slot-scope="scope">
                <div class="operation-btn" v-if="scope.row.type == '0'">
                  <el-button type="text" class="operation" v-zoom="{ from: pageName, name: '修改' }"
                    @click="showCreateModuleDialog(2, scope.row)">修改</el-button>
                  <el-button type="text" class="operation" v-zoom="{ from: pageName, name: '删除' }"
                    @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </div>
                <div class="operation-btn" v-else-if="tabIndex == 4">
                  <el-button v-if="scope.row.approvalStatus == '-1'" @click="handleSubmit(scope.$index, scope.row)"
                    class="operation" type="text">
                    提交
                  </el-button>
                  <el-button v-if="scope.row.approvalStatus == '-1'" @click="handleEdit(scope.$index, scope.row,1)"
                    class="operation" type="text">
                    编辑
                  </el-button>
                  <el-button v-if="scope.row.approvalStatus == '5'||scope.row.approvalStatus == '1'||scope.row.approvalStatus == '3'" @click="handleEdit(scope.$index, scope.row,0)"
                    class="operation" type="text">
                    复制
                  </el-button>
                  <el-button type="text"
                    v-if="scope.row.approvalStatus == '1' || scope.row.approvalStatus == '2' || scope.row.approvalStatus == '-1' || scope.row.approvalStatus == '5'"
                    class="operation" v-zoom="{ from: pageName, name: '删除' }"
                    @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                  <el-button style="color: #DDD; cursor: not-allowed;" v-else type="text" :disabled="true">
                    删除
                  </el-button>
                </div>
                <div v-else>--</div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="form.size"
              layout="total, sizes, prev, pager, next, jumper" :total="totalList"
              :current-page="form.current"></el-pagination>
          </div>
        </div>
        <!-- 富信模板 -->
        
        <div style="display: flex;" v-if="tabIndex == 5">
          <div style="flex:1;margin-bottom: 12px;" >
            <el-button type="primary" @click="showCreateModuleDialog1(1)" style="font-size: 14px">创建模板
            </el-button>
          </div>
          
          <el-form ref="formSearch" :inline="true" :model="formDataMedia" label-width="80px">
            <el-form-item label="模板名称:">
              <el-input size="small" v-model="formDataMedia.name"></el-input>
            </el-form-item>
            <el-form-item label="创建时间:">
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formDataMedia.startTime"
                  type="datetime"
                  :placeholder="'选择日期时间'"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="startTimeOption"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 120px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                ></el-date-picker>
                <div class="time_to_text" style="margin-top: 1px !important">
                  至
                </div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formDataMedia.endTime"
                  type="datetime"
                  :placeholder="'选择日期时间'"
                  :picker-options="endTimeOption"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 145px; font-size: 12px"
                  default-time="23:59:59"
                  class="time2"
                  :clearable="false"
                ></el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  @click="clearTimeSendTime()"
                ></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt
                  class="date_icon2"
                />
              </div>
            </el-form-item>
            <el-form-item label="状态:">
              <el-select v-model="formDataMedia.status">
                <el-option value="" label="全部"></el-option>
                <el-option value="0" label="待网关审核"></el-option>
                <el-option value="1" label="待运营审核"></el-option>
                <el-option value="2" label="审核通过(可投放)"></el-option>
                <el-option value="3" label="审核拒绝"></el-option>
                <el-option value="4" label="已绑定"></el-option>
                <el-option value="5" label="已过期"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="margin-right:0">
              <el-button size="small" class="search button-status5" type="primary"  @click="submitFormMedia"> 
                <i class="el-icon-search" style="display:inline-block;width:14px;height:12px;"></i> 查询
              </el-button>
              <el-button size="small" class="reset"  @click="resetFormMedia">重置</el-button>
            </el-form-item>
          </el-form>  
        </div>
        <div style="color: red;margin-bottom: 8px;" v-if="tabIndex == 5">*模板审核预计2-4个工作日，请至少提前2个工作日创建模板，模板审核通过后才可在短信发送任务中选上模板使用。</div>
        <div class="table-content" style="width: 100%;margin-left: 0;" v-if="tabIndex == 5">
          <el-table v-loading="tableLoading" tooltip-effect="light" :data="mediaTableData"
            :header-cell-style="{ background: '#FAFAFA' }">
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column key="mediaTemplateId" label="模板ID" prop="mediaTemplateId"></el-table-column>
            <el-table-column key="name" label="模板名称" prop="name"></el-table-column>
            <el-table-column label="模板内容" key="title">
              <template slot-scope="scope">
                <span class="operation" @click="lookTemplate(scope.row)">{{ scope.row.title }}</span>
              </template>
            </el-table-column>
            <el-table-column key="createTime" label="创建时间" prop="createTime"></el-table-column>
            <el-table-column key="status" label="状态" prop="status">
              <template slot-scope="scope">
                <span v-if="scope.row.status == '0'">待网关审核</span>
                <span v-if="scope.row.status == '1'">待运营审核</span>
                <span v-if="scope.row.status == '2'">审核通过(可投放)</span>
                <span v-if="scope.row.status == '3'">审核拒绝</span>
                <span v-if="scope.row.status == '4'">已绑定</span>
                <span v-if="scope.row.status == '5'">已过期</span>
                
              </template>
            </el-table-column>
            <el-table-column label="操作" width="250px">
              <template slot-scope="scope">
                <div class="operation-btn">
                  <el-button type="text" class="operation" style="width: 64px;" v-zoom="{ from: pageName, name: '复制新建' }"
                    @click="showCreateModuleDialog1(2, scope.row)">复制新建</el-button>
                  <el-button v-if="scope.row.status == '3' || scope.row.status == '5'" type="text" class="operation" v-zoom="{ from: pageName, name: '删除' }"
                    @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                  <el-button v-if="scope.row.status == 2" type="text" class="operation" style="width: 64px;" v-zoom="{ from: pageName, name: '测试发送' }"
                    @click="handleTest(scope.$index, scope.row)">测试发送</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination @size-change="handleSizeChange1" background @current-change="handleCurrentChange1"
              :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="mediaForm.size"
              layout="total, sizes, prev, pager, next, jumper" :total="totalList"
              :current-page="mediaForm.current"></el-pagination>
          </div>
        </div>
        <!-- 卡片模板 -->
        <div v-if="tabIndex == 6">
          <img src="@/assets/images/backstage/cardmodel.png" alt="卡片短信示例" width="1430" height="340">
        </div>
        <!-- 卡片素材 -->
        <div v-if="tabIndex == 7">
          
          <el-form ref="formSearch" :inline="true" :model="formDataFile" label-width="80px">
            <el-form-item label="素材名称:">
              <el-input class="w280" size="small" v-model="formDataFile.mediaName"></el-input>
            </el-form-item>
            <el-form-item label="素材类型:">
              <el-select v-model="formDataFile.mediaType" class="w280">
                <el-option value="" label="全部"></el-option>
                <el-option value="1" label="图片"></el-option>
                <el-option value="2" label="视频"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态:">
              <el-select v-model="formDataFile.status" class="w280">
                <el-option value="" label="全部"></el-option>
                <el-option value="0" label="待审核"></el-option>
                <el-option value="1" label="审核中"></el-option>
                <el-option value="2" label="审核通过"></el-option>
                <el-option value="3" label="审核拒绝"></el-option>
                <el-option value="4" label="已过期"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间:">
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formDataFile.startTime"
                  type="datetime"
                  :placeholder="'选择日期时间'"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="startTimeFileOption"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 120px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                ></el-date-picker>
                <div class="time_to_text" style="margin-top: 1px !important">
                  至
                </div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formDataFile.endTime"
                  type="datetime"
                  :placeholder="'选择日期时间'"
                  :picker-options="endTimeFileOption"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 145px; font-size: 12px"
                  default-time="23:59:59"
                  class="time2"
                  :clearable="false"
                ></el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  @click="clearFileTime()"
                ></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt
                  class="date_icon2"
                />
              </div>
            </el-form-item>
            <el-form-item label=" ">
              <el-button size="small" class="search button-status5" type="primary"  @click="submitFormFile"> 
                <i class="el-icon-search" style="display:inline-block;width:14px;height:12px;"></i> 查询
              </el-button>
              <el-button size="small" class="reset"  @click="resetFormFile">重置</el-button>
            </el-form-item>
          </el-form> 
          <div style="margin-bottom: 12px;">
            <el-button type="primary" @click="showAddResourcesDialog" style="font-size: 14px">添加素材
            </el-button>
          </div> 
        </div>
        <div class="table-content" style="width: 100%;margin-left: 0;" v-if="tabIndex == 7">
          <el-table v-loading="tableFileLoading" tooltip-effect="light" :data="fileTableData"
            :header-cell-style="{ background: '#FAFAFA' }">
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column key="mediaName" label="素材名称" prop="mediaName"></el-table-column>
            <el-table-column label="素材类型" prop="mediaType">
              <template slot-scope="scope">

                <span v-if="scope.row.mediaType == '1'">图片</span>
                <span v-if="scope.row.mediaType == '2'">视频</span>
              </template>
            </el-table-column>
            <el-table-column key="createDate" label="创建时间" prop="createDate"></el-table-column>
            <el-table-column key="status" label="状态" prop="status">
              <template slot-scope="scope">
                <span v-if="scope.row.status == '0'">待审核</span>
                <span v-if="scope.row.status == '1'">审核中</span>
                <span v-if="scope.row.status == '2'">审核通过</span>
                <span v-if="scope.row.status == '3'">审核拒绝</span>
                <span v-if="scope.row.status == '4'">已过期</span>
                <el-tooltip class="item" effect="dark" :content="scope.row.rejectMsg" placement="top-start"
                    v-if='scope.row.rejectMsg'>
                    <i class="el-icon-question" style="cursor: pointer;color: #ff5e61;"></i>
                  </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="250px">
              <template slot-scope="scope">
                <div class="operation-btn">
                  <el-button v-if="scope.row.status == '3' || scope.row.status == '4'" type="text" class="operation" v-zoom="{ from: pageName, name: '删除' }"
                    @click="handleDeleteFile(scope.$index, scope.row)">删除</el-button>
                  <el-button type="text" class="operation"  v-zoom="{ from: pageName, name: '预览' }"
                    @click="showFileDialog(scope.row)">预览</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination @size-change="handleSizeChangeFile" background @current-change="handleCurrentChangeFile"
              :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formDataFile.size"
              layout="total, sizes, prev, pager, next, jumper" :total="fileTotal"
              :current-page="formDataFile.current"></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="content-box" v-if="tabIndex == 6">
      <div class="content-table">
        <div>
          <el-form ref="formSearch" :inline="true" :model="formDataCard" label-width="80px">
            <el-form-item label="模板ID:">
              <el-input size="small" v-model="formDataCard.mediaTemplateId" class="w280"></el-input>
            </el-form-item>
            <el-form-item label="模板名称:">
              <el-input size="small" v-model="formDataCard.name" class="w280"></el-input>
            </el-form-item>
            <el-form-item label="模板类型:">
              <el-select v-model="formDataCard.type" class="w280">
                <el-option value="" label="全部"></el-option>
                <el-option value="1" label="图文单卡片"></el-option>
                <el-option value="2" label="视频单卡片"></el-option>
                <el-option value="3" label="图片轮播卡片"></el-option>
                <el-option value="4" label="红包卡片"></el-option>
                <el-option value="5" label="商品卡片"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态:">
              <el-select v-model="formDataCard.status" class="w280">
                <el-option value="" label="全部"></el-option>
                <el-option value="0" label="待网关审核"></el-option>
                <el-option value="1" label="待运营审核"></el-option>
                <el-option value="2" label="审核通过(可投放)"></el-option>
                <el-option value="3" label="审核拒绝"></el-option>
                <el-option value="4" label="已绑定"></el-option>
                <el-option value="5" label="已过期"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间:">
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formDataCard.startTime"
                  type="datetime"
                  :placeholder="'选择日期时间'"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="startTimeCardOption"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 120px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                ></el-date-picker>
                <div class="time_to_text" style="margin-top: 1px !important">
                  至
                </div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formDataCard.endTime"
                  type="datetime"
                  :placeholder="'选择日期时间'"
                  :picker-options="endTimeCardOption"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 145px; font-size: 12px"
                  default-time="23:59:59"
                  class="time2"
                  :clearable="false"
                ></el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  @click="clearCardTime()"
                ></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt
                  class="date_icon2"
                />
              </div>
            </el-form-item>
            <el-form-item label=" ">
              <el-button size="small" class="search button-status5" type="primary"  @click="submitFormCard"> 
                <i class="el-icon-search" style="display:inline-block;width:14px;height:12px;"></i> 查询
              </el-button>
              <el-button size="small" class="reset"  @click="resetFormCard">重置</el-button>
            </el-form-item>
          </el-form> 
          <div style="margin-bottom: 12px;">
            <el-button type="primary" @click="showCreateCardDialog(1)" style="font-size: 14px;margin-right: 12px;">创建模板
            </el-button>
            <span style="color: red;">*模板审核预计2-4个工作日，请至少提前2个工作日创建模板，模板审核通过后才可在短信发送任务中选上模板使用。</span>
          </div> 
        </div>
        <div class="table-content" style="width: 100%;margin-left: 0;">
          <el-table v-loading="tableCardLoading" tooltip-effect="light" :data="cardTableData"
            :header-cell-style="{ background: '#FAFAFA' }">
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column key="mediaTemplateId" label="模板ID" prop="mediaTemplateId"></el-table-column>
            <el-table-column key="name" label="模板名称" prop="name"></el-table-column>
            <el-table-column key="type" label="模板类型" prop="type">
              <template slot-scope="scope">
                <span v-if="scope.row.type == '1'">图文单卡片</span>
                <span v-if="scope.row.type == '2'">视频单卡片</span>
                <span v-if="scope.row.type == '3'">图片轮播卡片</span>
                <span v-if="scope.row.type == '4'">红包卡片</span>
                <span v-if="scope.row.type == '5'">商品卡片</span>
              </template>
            </el-table-column>
            <el-table-column label="模板内容" key="title">
              <template slot-scope="scope">
                <span class="operation" @click="lookTemplateCard(scope.row)">{{ scope.row.title }}</span>
              </template>
            </el-table-column>
            
            <el-table-column key="createTime" label="创建时间" prop="createTime"></el-table-column>
            <el-table-column key="status" label="状态" prop="status">
              <template slot-scope="scope">
                <span v-if="scope.row.status == '0'">待网关审核</span>
                <span v-if="scope.row.status == '1'">待运营审核</span>
                <span v-if="scope.row.status == '2'">审核通过(可投放)</span>
                <span v-if="scope.row.status == '3'">审核拒绝</span>
                <span v-if="scope.row.status == '4'">已绑定</span>
                <span v-if="scope.row.status == '5'">已过期</span>
                <el-tooltip class="item" effect="dark" :content="scope.row.auditMsg" placement="top-start"
                    v-if='scope.row.auditMsg'>
                    <i class="el-icon-question" style="cursor: pointer;color: #ff5e61;"></i>
                  </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="250px">
              <template slot-scope="scope">
                <div class="operation-btn">
                  <el-button type="text" class="operation" style="width: 64px;" v-zoom="{ from: pageName, name: '复制新建' }"
                    @click="showCopyCreateCardDialog(scope.row)">复制新建</el-button>
                  <el-button type="text" v-if="scope.row.status == '3' || scope.row.status == '5'" class="operation" v-zoom="{ from: pageName, name: '删除' }"
                    @click="handleDeleteCard(scope.$index, scope.row)">删除</el-button>
                  <el-button v-if="scope.row.status == 2" type="text" class="operation" style="width: 64px;" v-zoom="{ from: pageName, name: '测试发送' }"
                    @click="handleTest(scope.$index, scope.row)">测试发送</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination @size-change="handleSizeChangeCard" background @current-change="handleCurrentChangeCard"
              :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formDataCard.size"
              layout="total, sizes, prev, pager, next, jumper" :total="cardTotal"
              :current-page="formDataCard.current"></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加栏目弹窗 -->
    <el-dialog :visible.sync="addColumnDialog" title="添加栏目" width="582px">
      <div class="order-line">
        <span>栏目名称：</span>
        <el-input v-model="title" placeholder="请输入栏目名称"></el-input>
      </div>
      <div class="btn-group">
        <el-button :style="{ color: globalBG, 'border-color': globalBG }" @click="addColumnDialog = false"
          style="font-size: 14px">取消</el-button>
        <el-button type="primary" style="font-size: 14px" @click="handleAddColumn">确定</el-button>
      </div>
    </el-dialog>

    <!-- 删除栏目 -->
    <el-dialog :visible.sync="delColumnDialog" title="删除栏目" width="430px">
      <div class="order-line">
        <span>选择栏目：</span>
        <el-select style="width: 280px" v-model="delTid">
          <el-option v-for="(item, index) in columnList" :key="index" :label="item.title" :value="item.tid"></el-option>
        </el-select>
      </div>
      <div class="btn-group">
        <el-button :style="{ color: globalBG, 'border-color': globalBG }" style="font-size: 14px"
          @click="delColumnDialog = false">取消</el-button>
        <el-button type="primary" style="font-size: 14px" @click="handleDelColumn">确定</el-button>
      </div>
    </el-dialog>

    <!-- 创建模板 -->
    <el-dialog :visible.sync="addModuleDialog" :title="addModuleTitle" width="582px">
      <div class="order-line">
        <span>短信内容：</span>
        <el-input placeholder="请输入短信名称" type="textarea" v-model="moduleForm.content"
          :autosize="{ minRows: 4, maxRows: 8 }"></el-input>
      </div>
      <div class="order-line" style="margin-top: 16px">
        <span>选择栏目：</span>
        <el-select style="width: 280px" v-model="moduleForm.tid">
          <el-option v-for="(item, index) in columnList" :key="index" :label="item.title" :value="item.tid"></el-option>
        </el-select>
      </div>
      <div class="btn-group">
        <el-button :style="{ color: globalBG, 'border-color': globalBG }" style="font-size: 14px"
          @click="addModuleDialog = false">取消</el-button>
        <el-button type="primary" style="font-size: 14px" @click="handleTemplate">确定</el-button>
      </div>
    </el-dialog>
    <!-- 富信创建模板 -->
    <el-dialog :visible.sync="addModuleDialog1" :title="addModuleTitle" width="1400px">
      <div>
        <el-form label-width="90px">
          <el-form-item label="模板名称:" required>
            <el-input v-model="mediaFormUpdate.name" style="width: 300px;" size="small" maxlength="15"
              show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="富信模板:" required>
            <rich-message v-model="richMessageData" :returnData="returnData" :isAdapter="false" />
          </el-form-item>
        </el-form>
      </div>
      <div class="btn-group" style="text-align: right;">
        <el-button :style="{ color: globalBG, 'border-color': globalBG }" style="font-size: 14px"
          @click="addModuleDialog1 = false">取消</el-button>
        <el-button type="primary" style="font-size: 14px" @click="handleMediaTemplate">确定</el-button>
      </div>
    </el-dialog>

    <!-- 添加官方申请模板 -->
    <el-dialog :visible.sync="showModuleOffical" :title="isCreate?'创建模板':'编辑模板'" width="950px" :close-on-click-modal="false">
      <div class="create-module">
        <el-form :model="moduleOForm" label-width="90px">
          <el-form-item label="模板名称:" required>
            <el-input v-model="moduleOForm.name" show-word-limit style="width: 452px" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="选择栏目:" required>
            <el-select style="width: 452px" v-model="moduleOForm.tid" @change="switchOColumn">
              <el-option v-for="(item, index) in columnOfficialList" :key="index" :label="item.title"
                :value="item.tid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="短信变量:">
            <div class="variable-box">
              <div class="v-item" @click="insertContent(item)" :style="{ 'background-color': globalBG }"
                v-for="(item, index) in varilist" :key="index">
                {{ item | enVToChinese }}
              </div>
            </div>
          </el-form-item>
          <el-form-item label="短信内容:" required>
            <div class="content-wrap">
              <el-input placeholder="请输入短信名称" id="smsContent" type="textarea" style="width: 452px"
                v-model="moduleOForm.content" show-word-limit maxlength="200"
                :autosize="{ minRows: 4, maxRows: 8 }"></el-input>
              <div class="footInfo" style="width: 452px">
                <div>
                  <span>
                    已输入
                    <span :style="{ color: globalBG }">{{ sendInfoLength }}</span>
                    个字（含签名及退订文字），预计
                    <span :style="{ color: globalBG }">{{ Math.ceil(sendInfoLength > 70 ? sendInfoLength / 67 :
                      sendInfoLength / 70) }}</span>
                    条短信
                  </span>
                </div>
                <div>
                  <div class="ask_content">
                    <span style="font-weight: normal; margin-left: 12px" class="contentButtom">计费规则</span>
                    <span class="question_icon" style="margin-left: 4px">?</span>
                    <div class="ask-icon-select">
                      <div>1.70个字计1条短信，超过70字按照67字每条计费。</div>
                      <div>2.一个汉字，字母或标点空格都算作一个字。</div>
                      <div>
                        3.带标签短信以实际发送为准，有可能超过默认字数。
                      </div>
                      <div>4."签名"与"{{ TTip }}"包含在字数中。</div>
                      <div>5.短链及前后空格占17字或15字，插入短网址的原始域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，短链转换后的字符数及前后空格占17字（具体见插入链接说明）</div>
                      <div>6.含插入#评价链接#或#付款链接#短信变量，变量转换后，实际长度为15字。</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="辅助工具:" v-if='longlinkFlay'>
            <div class="tool">
              <p @click.prevent="handleShowShortLink">
                <i class="iconfont iconbtn_duanwangzhi"></i>
                插入短网址
              </p>
            </div>
          </el-form-item>
          <el-form-item label="短信签名:">
            <div class="btnList">
              <div class="btnBox" v-for="(item, index) in suffixList" :key="index">
                <el-button class="btn" style="width: auto; font-size: 14px" @click="switchSuffix(index)" :style="{
                  color: selectSuffix == item ? globalBG : '',
                  'border-color': selectSuffix == item ? globalBG : '',
                }">{{ item }}</el-button>
                <span class="check" :style="{
                  'background-color': selectSuffix == item ? globalBG : '',
                }">
                  <i class="el-icon-check"></i>
                </span>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <!-- 短信预览效果 -->
        <div class="xiao-hug xiao_hug2">
          <div style="margin: 0 auto; width: 256px">
            <div class="mobile-box" :style="{ background: 'url(' + mobileScreen + ') no-repeat' }">
              <div class="message-content" style>【{{ selectSuffix }}】{{ moduleOForm.content }}{{ TTip }}</div>
            </div>
            <div class="mobile-tips">短信预览效果</div>
          </div>
        </div>
      </div>
      <div class="btn-group btn-official">
        <el-button :style="{ color: globalBG, 'border-color': globalBG }" style="font-size: 14px"
          @click="showModuleOffical = false">取消</el-button>
        <el-button type="primary" style="font-size: 14px" @click="handleOTemplate('save')" :disabled="createLoading"
          v-loading="createLoading">保存</el-button>
        <el-button type="primary" style="font-size: 14px" @click="handleOTemplate('commit')" :disabled="commitLoading"
          v-loading="commitLoading">提交</el-button>
      </div>
      <!-- 插入短链接 -->
      <insert-short-dialog v-if="insertShortUrlShow" :typeSms="smsType" @close="handleCloseShort"></insert-short-dialog>
    </el-dialog>
    <!-- 富信模板 -->
    <sms-info v-if="smsInfoShow" @close="handleCloseSmsInfo" :isShow="smsInfoShow" :id="smsInfoRowData.contentId"
      :title="smsInfoRowData.title" :text="smsInfoRowData.text" />
    <sendTestMedia v-if="sendTestShow" @close="sendTestShow = false" :type="tabIndex == 6" :content="cardContent" :id="testId" :mediaTemplateId="mediaTemplateId">

    </sendTestMedia>
    <addCardSource v-if="addCardSourceShow" @close="addCardSourceShow = false" @confirm="addSourceConfirm"></addCardSource>
    <addCardModel v-if="addCardModelShow" @close="addCardModelShow = false" :id="cardCreateId" @confirm="addModelConfirm"></addCardModel>
    <withoutQualification v-if="withoutQualificationShow" @close="withoutQualificationShow = false"></withoutQualification>
    <sms-info-card v-if="smsInfoCardShow" :isShow="smsInfoCardShow" @close="smsInfoCardShow = false" :id="cardId"></sms-info-card>
    <sourceDialog v-if="sourceShow" :type="sourceType" :url="cardSourceUrl" @close="sourceShow = false"></sourceDialog>
  </div>
</template>
<script>
import insertShortDialog from "@/components/insert-short-dialog";
import topTitle from "@/components/top-title.vue";
import smsInfo from '@/components/sms-info'
import smsInfoCard from '@/components/sms-info-card'
import richMessage from '@/components/rich-message'
import sendTestMedia from './dialog/sendTestMedia'
import withoutQualification from './dialog/withoutQualification';
import addCardSource from './dialog/addCardSource';
import addCardModel from './dialog/addCardModel';
import sourceDialog from './dialog/sourceDialog';
import { getPrecisionJdSuffixList } from "@/api/precisionJdSuffix";
import {
  getTemplatesPage,
  addCustomerOfficialTemplate,
  commitOfficialTemplate,
  getOfficialTemplateDir,
  deleteTemplateDir,
  deleteTemplate,
  delBusApplyTemplate,
  createAddColumn,
  getTemplateDir,
  createTemplate,
  updateTemplate,
  getTemplateChild,
  getSmsMediaTemplate,
  getSmsMediaTemplateDetail,
  smsMediaTemplateDelete,
  smsMediaTemplateSave,
} from "@/api/smsTemplates";
import { getCardFileList,deleteCardFile,getCardList,deleteCard } from '@/api/backstage/smsCard'
import { mapState, mapMutations } from "vuex";
export default {
  name: "",
  components: {
    topTitle,
    insertShortDialog,
    smsInfo,
    richMessage,
    sendTestMedia,
    withoutQualification,
    smsInfoCard,
    addCardSource,
    addCardModel,
    sourceDialog
  },
  data() {
    return {
      sourceShow:false,
      sourceType:1,
      cardSourceUrl:'',
      addCardModelShow:false,
      addCardSourceShow:false,
      cardId:null,
      cardCreateId:null,
      smsInfoCardShow:false,
      withoutQualificationShow:false,
      testId:'',
      cardContent:'',
      sendTestShow:false,
      isCreate: true, // 是否为创建模板
      longlinkFlay: true,
      venderType: this.$store.state.loginUserInfo.venderType,
      pageName: "后台管理-短信模板",
      name: "短信模板",
      varilist: [],
      examineList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "待审核",
          value: "0",
        },
        {
          label: "通过",
          value: "1",
        },
        {
          label: "拒绝",
          value: "2",
        },
      ],
      formData: {
        content: "",
        officialTemplateId: "",
        approvalStatus: "",
        isBusinessApply: true,
      },
      formDataMedia:{
        name:'',
        startTime:'',
        endTime:'',
        status:'',
      },
      formDataFile:{
        size: 10,
        current: 1,
        mediaName:'',
        mediaType:'',
        startTime:'',
        endTime:'',
        status:'',
      },
      formDataCard:{
        size: 10,
        current: 1,
        mediaTemplateId:'',
        name:'',
        type:'',
        startTime:'',
        endTime:'',
        status:'',
      },
      cardTotal:0,
      fileTotal:0,
      startTimeOption: {
        disabledDate: (date) => {
            var endTime = this.formDataMedia.endTime;
            var time = date.getTime();
            var isDisabled = false;
            if (endTime) {
                isDisabled = time > new Date(endTime).getTime();
            }
            return isDisabled;
            }
        },
      endTimeOption: {
        disabledDate: (date) => {
        var startTime = this.formDataMedia.startTime;
        var time = date.getTime();
        var isDisabled = false;
        if (startTime) {
            isDisabled = time < new Date(startTime).getTime();
        }
        return isDisabled;
        }
      },
      startTimeFileOption: {
        disabledDate: (date) => {
            var endTime = this.formDataFile.endTime;
            var time = date.getTime();
            var isDisabled = false;
            if (endTime) {
                isDisabled = time > new Date(endTime).getTime();
            }
            return isDisabled;
            }
        },
      endTimeFileOption: {
        disabledDate: (date) => {
        var startTime = this.formDataFile.startTime;
        var time = date.getTime();
        var isDisabled = false;
        if (startTime) {
            isDisabled = time < new Date(startTime).getTime();
        }
        return isDisabled;
        }
      },
      startTimeCardOption: {
        disabledDate: (date) => {
            var endTime = this.formDataCard.endTime;
            var time = date.getTime();
            var isDisabled = false;
            if (endTime) {
                isDisabled = time > new Date(endTime).getTime();
            }
            return isDisabled;
            }
        },
      endTimeCardOption: {
        disabledDate: (date) => {
        var startTime = this.formDataCard.startTime;
        var time = date.getTime();
        var isDisabled = false;
        if (startTime) {
            isDisabled = time < new Date(startTime).getTime();
        }
        return isDisabled;
        }
      },
      title: "", // 栏目名称
      form: {
        tid: "",
        size: 10,
        current: 1,
      },
      totalList: 0,
      isShowSub: false,
      tabIndex: 0,
      moduleList: [
        // {
        //   title: "全部",
        //   id: ""
        // },
        // {
        //   title: "营销模板",
        //   id: "5",
        //   children: [
        //     {
        //       title: "秒杀",
        //       id: "51"
        //     }
        //   ]
        // }
      ],
      selectIndex: 0,
      selectSecondIndex: -1,
      tableData: [],
      mediaTableData: [], // 富信模板数据
      fileTableData:[], //
      cardTableData: [], //
      tableLoading: false,
      tableFileLoading: false,
      tableCardLoading: false,
      allShow: false, // 信息是否全部显示
      // 添加栏目弹窗
      addColumnDialog: false,
      // 删除栏目
      delColumnDialog: false,
      columnList: [],
      columnOfficialList: [],
      addModuleDialog: false,
      addModuleDialog1: false,
      addModuleTitle: "创建模板",
      status: 1, // 表示创建  2.表示编辑模板
      moduleForm: {
        content: "",
        tid: "",
        mid: "",
      },
      moduleOForm: {
        // 官方添加模板
        name: "",
        tid: "",
        content: "",
      },
      type: "", //  0 个人，1系统，2官方，不传查全部
      delTid: "", // 删除栏目ID
      showModuleOffical: false,
      createLoading: false,
      commitLoading: false,
      TTip: "拒收请回复R",
      insertShortUrlShow: false,
      smsType: 2,
      suffixList: [],
      selectSuffix: "",
      mobileScreen: require("@/assets/images/mobileScreen.png"),
      subLoading: false,
      mediaForm: {  // 富信模板列表查询
        size: 10,
        current: 1
      },
      mediaFormUpdate: {
        name: "",
        title: "",
        text: "",
        mediaList: "",
        totalSize: "",
      }, // 保存 -- 待提交数据
      smsInfoShow: false, // 富信模板预览弹窗
      smsInfoRowData: {}, // 富信预览模板数据
      richMessageData: {}, // 富信组件数据
      returnData:{
        totalSize:0,
        mediaTitle:"",
        content:"",
        mediaList:"",
        jdSmsSuffix:"",
        sourceUrl: '' // 原链接
      }
    };
  },
  created() {
    // 埋点
    this.buriedPoint(1, '短信模板', '后台管理', '短信管理')
  },
  mounted() {
    // console.log(this.$store.state.loginUserInfo.venderType);
    // var ModuleArr = [];
    // this.moduleList.forEach(item => {
    //   item["isExpand"] = true;
    //   ModuleArr.push(item);
    // });
    // this.moduleList = ModuleArr;
    if (this.$route.query && this.$route.query.type == "1") {
      // 模板选择弹窗的去创建模板跳转过来
      this.switchTab("4");
    }
    if (this.$route.query && this.$route.query.type == "5") {
      // 模板选择弹窗的去创建模板跳转过来
      this.switchTab("5");
    }else if (this.$route.query && this.$route.query.type == "6") {
      // 模板选择弹窗的去创建模板跳转过来
      this.switchTab("6");
    }else if (this.$route.query && this.$route.query.type == "7") {
      // 模板选择弹窗的去创建模板跳转过来
      this.switchTab("7");
    }else{
      this.getModuleList(); // 获取左边栏目列表
    }

    this.getDirList(); // 获取栏目列表
    this.getOfficilDirList(); // 获取官方栏目
    
    this.getOfficialSuffix();
  },
  methods: {
    handleEdit(index, row, type){
      // type  0新增  1编辑
      console.log(row);
      this.moduleOForm.name = row.name
      if(type){
        this.isCreate = false
      }else{
        this.isCreate = true
        this.moduleOForm.name = row.name+" "+"副本"
      }
      
      this.moduleOForm.tid = row.tid
      this.moduleOForm.mid = row.mid
      this.moduleOForm.content = this.$ChineseVToEn(row.content.split('拒收请回复R')[0], true)
      setTimeout(()=>{
        if(type){
          this.handleCreateO(1)
        }else{
          this.handleCreateO(0)
        }
      },200)
    },
    handleSubmit(index, row) {
      if (this.subLoading) {
        return;
      }
      var param = {
        mid: row.mid,
      };
      this.subLoading = true;
      commitOfficialTemplate(param).then((res) => {
        this.subLoading = false;
        if (res.code == "1") {
          this.showModuleOffical = false;
          this.$message.success("已提交！");
          this.getTemplateList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    switchSuffix(index) {
      this.selectSuffix = this.suffixList[index];
    },
    // 获取官方的短信签名
    getOfficialSuffix() {
      var type = 2;
      getPrecisionJdSuffixList(type).then((res) => {
        if (res.code == "1") {
          this.suffixList = res.data;
          this.selectSuffix = this.suffixList ? this.suffixList[0] : "";
          this.richMessageData.jdSmsSuffix = this.selectSuffix
        }
      });
    },

    // 关闭短链接
    handleCloseShort(val, obj) {
      this.insertShortUrlShow = false;
      if (val) {
        this.insertContent(" " + obj.shortLink + " ");
        // this.moduleOForm.content =
        //   this.moduleOForm.content + " " + obj.shortLink + " ";
      }
    },
    handleShowShortLink() {
      if (this.moduleOForm.content.indexOf("#自定义链接#") != -1) return this.$message.warning("短信内容中已插入“自定义链接变量”，请勿插入短链");
      this.insertShortUrlShow = true;
    },
    switchOColumn(obj) {
      // console.log(this.moduleOForm.tid, 66666666);
      // console.log(this.$store.state.loginUserInfo.venderType, "987654");
      if (typeof obj != "object") {
        obj = this.columnOfficialList.filter((cItem) => {
          return cItem.tid == obj;
        });
        obj = obj[0];
      }
      // console.log("89547", obj);
      var varList = JSON.parse(obj.propList);
      // console.log("111111", varList);
      var list = [];
      varList.forEach((vItem) => {
        list.push(vItem.valuie);
      });
      var listNum = ["#PayLink#", "#ShopName#", "#OrderId#"];
      var listNumOne = ["#ShopName#"];
      var listNumTwo = ["#ShopName#", "#OrderId#"];
      var listNumThree = ["#ShopName#", "#CommentLink#", "#OrderId#"];
      // var listNumFour = ["#ShopName#", "#CommentLink#"];
      var listNumFour = ["#ShopName#", "#CommentLink#", " #LandingPage#"];
      //判断是不是自营
      if (this.$store.state.loginUserInfo.venderType) {
        if (obj.modelType == 4 || obj.modelType == 1 || obj.modelType == 2) {
          this.varilist = listNum;
        } else if (obj.modelType == 3 || obj.modelType == 9) {
          this.varilist = listNumOne;
        } else if (obj.modelType == 10) {
          this.varilist = listNumTwo;
        } else if (obj.modelType == 5) {
          this.varilist = listNumThree;
        } else if (obj.modelType == 15) {
          this.varilist = listNumFour;
        } else {
          // console.log(2222);
          this.varilist = list;
        }
      } else {
        // console.log(33333, list);
        this.varilist = list;
      }
      this.longlinkFlay = this.varilist.indexOf('#LandingPage#') == -1 ? true : false
    },
    insertX() {
      this.moduleOForm.content = this.moduleOForm.content + "拒收请回复R";
    },
    handleCreateO(type) {
      this.isCreate = true
      this.showModuleOffical = true;
      if(type){
        this.isCreate = false
      }

      var tid = '';
      var columnOfficialList = this.columnOfficialList;

      if(this.isCreate){
        if(type === 0) {
          tid = this.moduleOForm.tid
        } else {
          tid = this.form.tid
          this.moduleOForm.tid = tid;
        }
      }else{
        tid = this.moduleOForm.tid
      }

      console.log(tid);

      var selectObj = null;
      if (tid) {
        selectObj = columnOfficialList.filter((item) => {
          return item.tid == tid;
        })[0];
      } else {
        selectObj = columnOfficialList[0];
        this.moduleOForm.tid = selectObj.tid;
      }
      console.log(selectObj);
      this.switchOColumn(selectObj);
    },
    insertContent(myValue) {
      myValue = this.$ChineseVToEn(myValue, true);
      const smsContent = document.querySelector("#smsContent");
      var startPos = smsContent.selectionStart;
      var endPos = smsContent.selectionEnd;
      // console.log("555555", smsContent, startPos, endPos, myValue);

      if (startPos || startPos.selectionStart == "0" || startPos === 0) {
        smsContent.value = smsContent.value.substring(0, startPos) + myValue + smsContent.value.substring(endPos, smsContent.value.length);
        smsContent.selectionStart = startPos + myValue.length;
        smsContent.selectionEnd = startPos + myValue.length;
        smsContent.focus();
      } else {
        smsContent.value += myValue;
        smsContent.focus();
      }
      this.moduleOForm.content = smsContent.value;
    },
    submitForm() {
      this.getTemplateList(2);
    },
    resetForm() {
      this.formData = {
        content: "",
        officialTemplateId: "",
        approvalStatus: "",
        isBusinessApply: true,
      };
      this.getTemplateList(2);
    },
    // 获取模板列表 type: 0 个人创建，1.系统模板 2.官方模板的 全部搜索
    getTemplateList(type) {
      // console.log("getTemplateList:==", type);
      this.tableLoading = true;
      var param = JSON.parse(JSON.stringify(this.form));
      if (type === 0 || type === 1 || type === 2) {
        param.type = type;
      }
      // console.log("this.param:", param);
      if (this.tabIndex == 4) {
        // 官方模板申请
        param = { ...param, ...this.formData, type: 2 };
        param.content = this.$ChineseVToEn(param.content);
      } else if (this.tabIndex == 1) {
        // 官方模板
        param["isBusinessApply"] = false;
      }
      getTemplatesPage(param).then((res) => {
        if (res.code == "1") {
          this.tableLoading = false;
          this.tableData = res.data.records;
          this.totalList = res.data.total;
        }
      });
    },

    //清除时间
    clearTimeSendTime(){
      this.formDataMedia.startTime = "";
      this.formDataMedia.endTime = "";
    },
    //清除时间
    clearFileTime(){
      this.formDataFile.startTime = "";
      this.formDataFile.endTime = "";
    },
    //清除时间
    clearCardTime(){
      this.formDataCard.startTime = "";
      this.formDataCard.endTime = "";
    },
    submitFormMedia(){
      this.mediaForm.current = 1;
      this.getSmsMediaTemplateList();
    },
    resetFormMedia(){
      this.formDataMedia.name = "";
      this.formDataMedia.status = "";
      this.formDataMedia.startTime = "";
      this.formDataMedia.endTime = "";
      this.submitFormMedia();
    },
    // 获取富信模板列表
    getSmsMediaTemplateList() {
      this.tableLoading = true;
      getSmsMediaTemplate({...this.formDataMedia,...this.mediaForm}).then(res => {
        if (res.code == 1) {
          // console.log(res);
          this.mediaTableData = res.data.records;
          this.totalList = res.data.total;
          this.tableLoading = false;
        }
      })
    },
    // 查看富信模板
    lookTemplate(val) {
      getSmsMediaTemplateDetail(val.id).then(res => {
        if (res.code == 1) {
          this.smsInfoRowData = res.data
          this.smsInfoRowData.contentId = val.mediaMulitiFileId
          this.smsInfoShow = true
        }
      })
    },
    // 素材模板分页
    handleSizeChangeFile(val) {
      this.formDataFile.size = val;
      this.getCardFileList();
    },
    handleCurrentChangeFile(val) {
      this.formDataFile.current = val;
      this.getCardFileList();
    },
    submitFormFile(){
      this.formDataFile.current = 1;
      this.getCardFileList();
    },
    resetFormFile(){
      this.formDataFile.mediaName = "";
      this.formDataFile.mediaType = "";
      this.formDataFile.status = "";
      this.formDataFile.startTime = "";
      this.formDataFile.endTime = "";
      this.submitFormFile();
    },
    getCardFileList(){
      this.tableFileLoading = true;
      getCardFileList(this.formDataFile).then(res=>{
        if (res.code == 1) {
          // console.log(res);
          this.fileTableData = res.data.records;
          this.fileTotal = res.data.total;
          this.tableFileLoading = false;
        }else{
          this.$message.warning(res.message);
        }
      })
    },
    lookFile(){

    },
    // 卡片模板分页
    handleSizeChangeCard(val) {
      this.formDataCard.size = val;
      this.getCardList();
    },
    handleCurrentChangeCard(val) {
      this.formDataCard.current = val;
      this.getCardList();
    },
    submitFormCard(){
      this.formDataCard.current = 1;
      this.getCardList();
    },
    resetFormCard(){
      this.formDataCard.mediaTemplateId = "";
      this.formDataCard.name = "";
      this.formDataCard.type = "";
      this.formDataCard.status = "";
      this.formDataCard.startTime = "";
      this.formDataCard.endTime = "";
      this.submitFormCard();
    },
    getCardList(){
      this.tableCardLoading = true;
      getCardList(this.formDataCard).then(res=>{
        if (res.code == 1) {
          // console.log(res);
          this.cardTableData = res.data.records;
          this.cardTotal = res.data.total;
          this.tableCardLoading = false;
        }else{
          this.$message.warning(res.message);
        }
      })
    },
    lookCard(){

    },
    // 关闭短信内容弹窗
    handleCloseSmsInfo() {
      this.smsInfoShow = false
    },

    // 富信编辑模板
    showCreateModuleDialog1(type, row) {
      // this.mediaFormUpdate = {}
      if (type == 1) {
        this.addModuleTitle = "创建模板";
        
        this.mediaFormUpdate.name = ''
        this.mediaFormUpdate.id = ''
        setTimeout(()=>{
          this.returnData.mediaTitle = ""
          this.returnData.content = ""
          this.returnData.totalSize = 0
          this.returnData.mediaList = []
          this.returnData.sourceUrl = ""
          this.addModuleDialog1 = true;
        },500)
      } else {
        this.addModuleTitle = "创建模板";
        getSmsMediaTemplateDetail(row.id).then(res => {
          if (res.code == 1) {
            this.addModuleDialog1 = true;
            this.mediaFormUpdate.name = res.data.name
            this.mediaFormUpdate.id = ''
            setTimeout(()=>{
              this.returnData.mediaTitle = res.data.title
              this.returnData.content = res.data.text
              this.returnData.totalSize = res.data.totalSize
              this.returnData.mediaList = res.data.mediaList
              this.returnData.sourceUrl = res.data.originUrl
            },500)
          }
        })
      }
    },

    // 富信保存模板
    handleMediaTemplate() {
      if (!this.mediaFormUpdate.name) {
        this.$message.warning("模板名称不能为空哦！");
        return;
      }
      if (!this.richMessageData.mediaTitle) {
        this.$message.warning("富信标题不能为空哦！");
        return;
      }
      if (!this.richMessageData.content) {
        this.$message.warning("富信内容不能为空哦！");
        return;
      }
      if (this.richMessageData.mediaList.length == 0) {
        this.$message.warning("请上传富媒体文件！");
        return;
      }
      this.mediaFormUpdate.title = this.richMessageData.mediaTitle
      this.mediaFormUpdate.text = this.richMessageData.content
      this.mediaFormUpdate.mediaList = this.richMessageData.mediaList
      this.mediaFormUpdate.totalSize = this.richMessageData.totalSize
      this.mediaFormUpdate.originUrl = this.richMessageData.sourceUrl
      smsMediaTemplateSave(this.mediaFormUpdate).then((res) => {
        if (res.code == "1") {
          this.$message.success("保存模板成功！");
          this.getSmsMediaTemplateList()
          this.addModuleDialog1 = false
        } else {
          this.$message.error(res.message);
        }
      })
    },

    // 添加素材
    showAddResourcesDialog(){
      if(this.$store.state.loginUserInfo.isMediaQualification){
        this.addCardSourceShow = true;
        console.log('res.showAddResourcesDialog',this.addCardSourceShow);
      }else{
        this.withoutQualificationShow = true;
      }
    },
    addSourceConfirm(){
      this.submitFormFile();
      this.addCardSourceShow = false;
    },
    lookTemplateCard(val){
      this.cardId = val.mediaTemplateId;
      this.smsInfoCardShow = true
    },
    // 添加卡片模板
    showCreateCardDialog(){
      if(this.$store.state.loginUserInfo.isMediaQualification){
        this.cardCreateId = null;
        this.addCardModelShow = true;
      }else{
        this.withoutQualificationShow = true;
      }
    },
    showCopyCreateCardDialog(row){
      if(this.$store.state.loginUserInfo.isMediaQualification){
        this.cardCreateId = row.id;
        this.addCardModelShow = true;
      }else{
        this.withoutQualificationShow = true;
      }
    },
    addModelConfirm(){
      this.submitFormCard();
      this.addCardModelShow = false;
    },
    // 获取栏目列表
    getModuleList() {
      // type 类型： 0 个人，1系统，2官方，不传查全部
      var type = this.type;
      var param = {
        type: type || 0,
      };
      getTemplateDir(param).then((res) => {
        if (res.code == "1") {
          this.moduleList = res.data;
          var orignListOfficial = [
            {
              title: "订单关怀模板",
              tid: "4",
              child: true,
              isExpand: false,
            },
            // {
            //   title: "自动化营销模板",
            //   tid: "5",
            //   child: true,
            //   isExpand: false,
            // },
          ]; // 官方模板
          var orignList = [
            {
              title: "全部",
              tid: "",
            },
          ];
          if (type === "" || type == "1") {
            orignList = [
              {
                title: "全部",
                tid: "",
              },
              {
                title: "物流模板",
                tid: "1",
                child: true,
                isExpand: false,
              },
              {
                title: "节日模板",
                tid: "2",
                child: true,
                isExpand: false,
              },
              {
                title: "营销模板",
                tid: "3",
                child: true,
                isExpand: false,
              },
            ];
          }
          if (type == "2" || type === "") {
            orignList = orignList.concat(orignListOfficial);
          }
          if (type == "2") {
            // 官方
            this.moduleList = orignList;
          } else {
            this.moduleList = orignList.concat(this.moduleList);
          }

          this.selectIndex = 0;
          this.selectSecondIndex = -1;
          this.getTemplateList(this.type);
        }
      });
    },
    isRepeat(arr) {
      var hash = {};
      for (var i in arr) {
        if (hash[arr[i]]) {
          return true;
        }
        // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
        hash[arr[i]] = true;
      }
      return false;
    },
    // 创建官方申请模板
    async handleOTemplate(type) {
      if (!this.moduleOForm.name) {
        this.$message.warning("创建模板的模板名称不能为空哦！");
        return;
      }
      var content = this.moduleOForm.content;
      if (this.isRepeat(content.match(/3\.cn/g))) {
        this.$message.warning("官方插入的短链接不允许超过1个哦！");
        return;
      }
      if (!content) {
        this.$message.warning("创建模板的短信内容不能为空哦！");
        return;
      }
      if (!this.moduleOForm.tid) {
        this.$message.warning("请选择栏目");
        return;
      }

      let obj = this.columnOfficialList.filter((item) => {
        return item.tid == this.moduleOForm.tid;
      });
      obj = obj[0];
      console.log(obj);
      var param = {
        content: this.$ChineseVToEn(content) + this.TTip,
        tid: obj.tid,
        name: this.moduleOForm.name,
        modelType: obj.modelType,
        officialModelTypeId: obj.officialModelTypeId,
      };
      if(!this.isCreate){
        param.mid = this.moduleOForm.mid;
      }

      // 敏感词检测
      // const checkResult = await this.$wordCheck({ content: this.moduleOForm.content })
      // if (checkResult.code != 1) {
      //   return this.$message.error(checkResult.message)
      // }

      if (type == "save") {
        this.createLoading = true;
        addCustomerOfficialTemplate(param).then((res) => {
          this.createLoading = false;
          if (res.code == "1") {
            this.showModuleOffical = false;
            if(this.isCreate){
              this.$message.success("创建模板成功！");
            }else{
              this.$message.success("保存模板成功！");
            }
            this.getTemplateList(2);
          } else {
            this.$message.error(res.message);
          }
        });
      } else if (type == "commit") {
        this.commitLoading = true;
        commitOfficialTemplate(param).then((res) => {
          this.commitLoading = false;
          if (res.code == "1") {
            this.showModuleOffical = false;
            this.$message.success("已提交！");
            this.getTemplateList(2);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 创建模板
    handleTemplate() {
      if (!this.moduleForm.content) {
        this.$message.warning("创建模板的短信内容不能为空哦！");
        return;
      }
      if (!this.moduleForm.tid) {
        this.$message.warning("请选择栏目");
        return;
      }
      if (this.status == "1") {
        this.addModuleDialog = false;
        // 创建模板
        var param = this.moduleForm;
        createTemplate(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("创建模板成功！");
            this.getTemplateList();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.addModuleDialog = false;
        // 编辑模板
        var param = this.moduleForm;
        updateTemplate(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("编辑模板成功！");
            this.getTemplateList();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },


    // 获取自定义栏目列表
    getDirList() {
      var param = {
        type: 0,
      };
      getTemplateDir(param).then((res) => {
        if (res.code == "1") {
          this.columnList = res.data;
        }
      });
    },

    // 获取官方栏目
    getOfficilDirList() {
      getOfficialTemplateDir().then((res) => {
        if (res.code == "1") {
          var list = res.data;
          // console.log("852369", list);
          // debugger
          list = list.filter((item) => {
            return item.publicType == "4";
          });
          this.columnOfficialList = list[0].child;
          // console.log(" this.columnOfficialList", this.columnOfficialList);
        }
      });
    },

    // 添加栏目
    handleAddColumn() {
      if (!this.title) {
        this.$message.warning("栏目名称不能为空哦！");
      } else {
        this.addColumnDialog = false;
        var param = {
          title: this.title,
        };
        createAddColumn(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("添加栏目成功！");
            this.getModuleList();
            this.getDirList();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },

    /*
     * 删除模板
     * */
    handleDelete(index, row) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      })
        .then(() => {
          if (this.tabIndex == "4") {
            // 删除官方申请模板
            var param = {
              id: row.mid,
            };
            delBusApplyTemplate(param).then((res) => {
              // console.log("res====", res);
              if (res.code == "1") {
                this.$message.success("删除成功");
                this.getTemplateList();
              } else {
                this.$message.error(res.data.message);
              }
            });
          } else if (this.tabIndex == "5") {
            // 删除富信模板
            smsMediaTemplateDelete(row.id).then((res) => {
              if (res.code == "1") {
                this.$message.success("删除成功");
                this.submitFormMedia();
              } else {
                this.$message.error('删除失败');
              }
            })
          } else {
            var param = {
              mid: row.mid,
            };
            deleteTemplate(param).then((res) => {
              if (res.code == "1") {
                this.$message.success("删除成功");
                this.getTemplateList();
              } else {
                this.$message.error(res.message);
              }
            });
          }
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 删除素材
    handleDeleteFile(index,row){
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(()=>{
        deleteCardFile(row.id).then(res=>{
          if(res.code == 1){
            this.submitFormFile();
            this.$message.success('删除成功');
          }else {
            this.$message.error(res.message);
          }
        });
      })
      .catch(() => {
        this.$message.info("已取消删除");
      });
      
    },
    // 删除卡片
    handleDeleteCard(index,row){
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(()=>{
        deleteCard(row.id).then(res=>{
          if(res.code == 1){
            this.submitFormCard();
            this.$message.success('删除成功');
          }else {
            this.$message.error(res.message);
          }
        });
      })
      .catch(() => {
        this.$message.info("已取消删除");
      });
      
    },
    // 预览素材
    showFileDialog(row){
      this.sourceShow = true;
      this.sourceType = row.mediaType
      this.cardSourceUrl = row.mulitiFileDatas.fileUrl
    },
    // 测试发送
    handleTest(index,row){
      this.testId = row.id;
      this.mediaTemplateId = row.mediaTemplateId;
      if(this.tabIndex == 6){
        this.cardContent = row.title;
      }
      this.sendTestShow = true;
    },

    // 显示创建模板
    showCreateModuleDialog(type, row) {
      if (type == 1) {
        this.addModuleTitle = "创建模板";
        this.status = 1;
        // var columnList = this.columnList;
        this.moduleForm = {
          content: "",
          // tid: this.form.tid || (columnList && columnList[0] && columnList[0].tid),
          tid: "",
        };
      } else {
        this.addModuleTitle = "编辑模板";
        this.status = 2;
        this.moduleForm = {
          content: row.content,
          tid: row.tid,
          mid: row.mid,
        };
      }
      this.addModuleDialog = true;
    },

    // 显示删除栏目
    showDelColumnDialog() {
      this.delTid = "";
      this.delColumnDialog = true;
    },
    // 删除栏目处理
    handleDelColumn() {
      this.delColumnDialog = false;
      var param = {
        tid: this.delTid,
      };
      deleteTemplateDir(param).then((res) => {
        if (res.code == "1") {
          this.$message.success("删除成功");
          this.getModuleList();
          // this.getTemplateList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 显示添加栏目
    showAddColumnDialog() {
      this.addColumnDialog = true;
    },
    // 切换模板
    switchTab(index) {
      // type 0 个人，1系统，2官方，不传查全部
      this.tabIndex = index;
      if (index == 5) {
        (this.mediaForm.size = 10), (this.mediaForm.current = 1);
        this.getSmsMediaTemplateList()
        return false
      }
      if (index == 6) {
        this.submitFormCard()
        return false
      }
      if (index == 7) {
        this.submitFormFile()
        return false
      }
      if (index == "1" || index == "4") {
        // 官方
        this.type = 2;
      } else if (index == "2") {
        // 系统
        this.type = 1;
      } else if (index == "3") {
        // 自定义
        this.type = 0;
      } else {
        // 全部
        this.type = "";
      }
      (this.form.size = 10), (this.form.current = 1);
      this.getModuleList();
    },
    handleSizeChange(val) {
      this.form.size = val;
      this.getTemplateList(this.type);
    },
    handleCurrentChange(val) {
      this.form.current = val;
      this.getTemplateList(this.type);
    },
    // 富信模板分页
    handleSizeChange1(val) {
      this.mediaForm.size = val;
      this.getSmsMediaTemplateList();
    },
    handleCurrentChange1(val) {
      this.mediaForm.current = val;
      this.getSmsMediaTemplateList();
    },

    handleClickFirst(i, secondI) {
      var obj = this.moduleList[i];
      if (!secondI && secondI != "0") {
        if (obj.child) {
          this.selectIndex = -1;
          if (obj.isExpand) {
            obj.isExpand = false;
          } else {
            this.getChildList(i);
          }
        } else {
          this.selectIndex = i;
          this.selectSecondIndex = -1;
          this.form = {
            tid: obj.tid,
            size: 10,
            current: 1,
          };
          var type = null;
          if (obj.tid == "") {
            type = this.type;
          }
          this.getTemplateList(type);
        }
      } else {
        this.selectSecondIndex = secondI;
        this.selectIndex = -1;
        this.form = {
          tid: obj.children[secondI].tid,
          size: 10,
          current: 1,
        };

        this.getTemplateList(type);
      }
    },

    // 获取子栏目
    getChildList(i) {
      // publicType 1表示物流模板 2表示节日模板，3表示营销模板
      var obj = this.moduleList[i];

      var param = {
        publicType: obj.tid,
      };
      getTemplateChild(param).then((res) => {
        if (res.code == "1") {
          obj.isExpand = !obj.isExpand;
          obj.children = res.data;
          this.$set(this.moduleList, i, obj);
        }
      });
    },
  },

  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
    // venderType() {
    //   // 是否为自营店铺
    //   return this.$store.getters.loginUserInfo.venderType;
    // },
    sendInfoLength() {
      return this.$linkConvertNum(this.moduleOForm.content) + this.selectSuffix
        ? this.$linkConvertNum(this.moduleOForm.content) + this.selectSuffix.length + this.TTip.length + 2
        : 2 + this.TTip.length;
    },
  },
};
</script>
<style scoped lang="scss">
.w280{
  width:280px;
}
.content-wrap {
  background: #f9fafb;
  width: 460px;
  padding: 0 5px;
}

.operation-btn .el-button {
  padding: 0 !important;
  width: 32px;
}

.footTips {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-top: 8px;
  padding-left: 12px;
  height: 28px;
  background: rgba(255, 250, 238, 1);
  // border: 1px solid rgba(255, 185, 94, 1);
  border-radius: 2px;
  color: #333;
  font-size: 13px;
}

.button-status5 {
  background-color: #fff;
  border: 1px solid #fe4d45;
  font-size: 14px;
  color: #fe4d45;

  &:hover {
    background-color: #fe4d45;
    border: 1px solid #fe4d45;
    color: #fff;
  }

  &:active {
    background-color: #fe4d45;
    border: #fe4d45;
    color: #fff;
  }
}

.tip-box {
  padding-top: 10px;

  p {
    margin-bottom: 5px;
  }
}

.insert-dom {
  display: inline-block;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  // margin-top: 5px;
  cursor: pointer;
  line-height: 15px;
}

.variable-box {
  width: 452px;

  .v-item {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    color: #fff;
    display: inline-block;
    margin-right: 10px;
    padding: 5px;
    border-radius: 4px;
    padding-top: 5px;
    margin-bottom: 5px;
    line-height: 15px;
  }
}

.search-box {
  padding-top: 17px;
  padding-bottom: 10px;

  .btn_group {
    text-align: center;
  }
}

.theTitle {
  min-width: 980px;
  height: 57px;
  line-height: 57px;
  padding: 0;
  color: #2e3458;
  font-weight: bold;
  margin: 20px;
  border: 1px solid rgba(230, 230, 230, 1);
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
}

.btn-line {
  margin-top: 20px;

  .el-button {
    width: 98px;
    height: 32px;
  }
}

.order-line {
  span {
    display: inline-block;
    width: 72px;
    text-align: right;
  }

  .el-input {
    display: inline-block;
    width: 470px;
  }

  .el-textarea {
    width: 440px;
    vertical-align: top;
  }
}

.operation {
  width: 60px;
  cursor: pointer;
  color: #7f85e9;

  &:hover {
    color: #fe4d45;
  }
}


.content-box {
  min-width: 1046px;
  background-color: #fff;
  border-radius: 6px;
  -webkit-box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 24px 28px;
  margin: 20px;

  .b1 {
    width: 98px;
    height: 32px;
    font-size: 14px;
    border-radius: 3px;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff;

    &:hover {
      color: #fff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
  }

  .b2 {
    width: 98px;
    height: 32px;
    color: #666666;
    font-size: 14px;
    border-radius: 3px;
    border: 1px solid #dddddd;
    background-color: #fff;

    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }

  .tab-line {
    border-bottom: 1px solid #dddddd;

    .tab-item {
      font-size: 14px;
      color: #666;
      display: inline-block;
      width: 106px;
      height: 36px;
      line-height: 36px;
      box-sizing: border-box;
      text-align: center;
      border: 1px solid #dddddd;
      border-bottom: none;
      margin-right: 2px;
      border-radius: 2px 2px 0 0;
      cursor: pointer;

      &.active {
        font-weight: 500;
        color: #fe4d45;
        border-top-width: 2px;
        border-top-color: #fe4d45;
        position: relative;

        &::after {
          content: "";
          display: block;
          width: 100%;
          height: 2px;
          position: absolute;
          left: 0;
          bottom: -2px;
          background-color: #fff;
        }
      }
    }
  }
}

.content-table {
  padding-top: 17px;

  // position: relative;
  // height: 722px;
  /** 左边菜单栏 */
  .left-menu {
    vertical-align: text-top;
    display: inline-block;
    font-size: 14px;
    color: #333333;
    width: 220px;
    border: 1px solid #eeeeee;
    padding: 12px 11px 12px 8px;
    box-sizing: border-box;
    // position: absolute;
    // top: 0;
    // left: 0;
    height: 722px;
    overflow: auto;

    p {
      margin: 0;
    }

    .first-menu {
      cursor: pointer;

      .title {
        padding-left: 24px;
        position: relative;
        line-height: 28px;
        display: inline-block;
        width: 195px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      i {
        color: #ccc;
        position: absolute;
        left: 8px;
        top: 50%;
        transform: translateY(-50%);
      }

      &.active {
        color: #fe4d45;
        background-color: #f6f6f6;
      }
    }

    .second-menu {
      font-size: 14px;
      color: #999;
      transition: height 0.3s linear;
      overflow: hidden;

      p {
        padding-left: 34px;
        line-height: 28px;
        cursor: pointer;

        &.active {
          color: #fe4d45;
          background-color: #f6f6f6;
        }
      }
    }
  }

  /** 右边表格 */
  .table-content {
    display: inline-block;
    vertical-align: text-top;
    margin-left: 20px;
    width: calc(100% - 250px);

    // height: 200px;
    // position: absolute;
    // right: 0;
    // left: 240px;
    .table-message {
      cursor: pointer;
      margin-left: 8px;
    }

    .module-content {
      // width: 430px;
      max-width: 430px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.pagination {
  text-align: right;
  margin-top: 20px;
}

.btn-group {
  text-align: left;
  margin-top: 20px;
  margin-left: 20px;

  .el-button {
    width: 98px;
  }
}

.footInfo {
  display: flex;
  justify-content: space-between;
  margin-top: 9px;
  font-size: 14px;
  color: #333;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 76px;
    height: 28px;
    outline: none;
    border: none;
    background-color: white;
    border-radius: 2px;
    font-size: 13px;
  }

  div {
    display: flex;
    align-items: center;
  }

  .select {
    cursor: pointer;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    border-radius: 3px;
    background-color: #fff4f4;

    &:hover {
      color: #fe4d45;
      background-color: #ffe5e5;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }

  .keep {
    margin: 0 10px 0 8px;
    cursor: pointer;
    color: #ffffff;
    border-radius: 3px;
    border: 1px solid #fe4d45;
    background-color: #fe4d45;

    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}

.ask_content {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-right: 2px;
  cursor: pointer;

  .ask-icon {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    position: relative;
  }

  .contentButtom {
    color: #7f85e9;

    &:hover {
      color: #fe4d45;
    }
  }

  .ask-icon-select {
    position: absolute;
    bottom: 38px;
    margin-left: -133px;
    display: none !important;
    width: 375px;
    // height: 80px;
    line-height: 20px;
    padding: 20px;
    background-color: #fff;
    text-align: left;
    box-shadow: 0 8px 20px rgba(139, 156, 188, 0.15);
    color: #999999;
    z-index: 1;
  }

  .ask-icon-select:before {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    right: 50%;
    margin-left: -4px;
    top: 100%;
    border-left: 8px solid transparent;
    border-top: 8px solid #fff;
    border-right: 8px solid transparent;
  }
}

.ask_content:hover {
  .ask-icon-select {
    display: block !important;
  }
}

.question_icon {
  width: 14px;
  height: 14px;
  color: #7f85e9 !important;
  display: inline-block;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #7f85e9;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 8px;

  &:hover {
    color: #fe4d45 !important;
    border: 1px solid #fe4d45;
  }
}

.tool {
  cursor: pointer;
  display: flex;
  align-items: center;

  p {
    box-sizing: border-box;
    padding: 0 8px;
    margin: 0 8px 0 0;
    // width: 98px;
    height: 32px;
    line-height: 28px;
    font-size: 14px;
    border-radius: 3px;
    background-color: #f7f8fe;
    border: 1px solid #7f85e9;
    color: #7f85e9;

    &:hover {
      background: rgba(174, 179, 241, 0.16);
      border: 1px solid #7f85e9 !important;
      color: #7f85e9 !important;
    }

    &:active {
      background: rgba(174, 179, 241, 0.24);
      border: 1px solid #7f85e9 !important;
      color: #7f85e9;
    }
  }
}

.btnList {

  // display: flex;
  // align-items: center;
  // height: 32px;
  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    margin: 0;
    border-radius: 2px;
    cursor: pointer;
  }

  .replaceButtom {
    cursor: pointer;
    color: rgb(127, 133, 233);

    &:hover {
      color: #fe4d45;
    }
  }

  .btnBox {
    display: inline-block;
    position: relative;
    overflow: hidden;
    height: 32px;
    margin-right: 20px;

    .btn {
      width: 114px;
      height: 31px;
      color: #999999;
      border: 1px solid #cccccc;
      padding-left: 15px;
      border-radius: 3px;
      padding-right: 15px;
      cursor: pointer;
    }

    .check {
      position: absolute;
      right: -16px;
      bottom: -16px;
      width: 30px;
      height: 30px;
      // background-color: #FE4D45;
      border-radius: 50%;
    }

    i {
      position: absolute;
      right: 16px;
      bottom: 15px;
      font-size: 10px;
      color: #fff;
    }
  }
}

.mobile-box {
  position: relative;
  width: 256px;
  // margin-top: 21px;
  height: 504px;

  // background: url("../../assets/images/mobileScreen.png") no-repeat;
  .message-content {
    position: absolute;
    word-wrap: break-word;
    max-height: 250px;
    overflow-y: auto;
    padding: 12px 12px;
    border-radius: 6px;
    width: 210px;
    font-size: 14px;
    background-color: #fafafa;
    line-height: 20px;
    left: 50%;
    margin-left: -104.665px;
    text-align: left;
    top: 25.4%;
  }
}

.mobile-tips {
  margin-top: 12px;
  font-size: 16px;
  text-align: center;
  color: rgba(51, 51, 51, 1);
}

.create-module {
  position: relative;

  .xiao_hug2 {
    position: absolute;
    top: 0px;
    left: 620px;
    // display: inline-block;
  }
}

.btn-official {
  margin-top: 200px;
}
</style>
